export enum ErrorCodes {
  INVALID_CREDENTIALS = 1002,
  BLOCKED_USER = 1008,
  PASSWORD_EXPIRED = 1009,
  PASSWORD_REUSE = 2633,
}
